import { Outlet } from "react-router-dom";
import AdminSidebar from "./components/AdminSidebar";

export const AdminLayout = () => {
  return (
    <div className="flex h-screen w-full pt-16">
      {/* Menú lateral */}
      <AdminSidebar />
      
      {/* Contenido - aquí se renderizarán las subrutas */}
      <div id="clients-content-container" className="flex-1 overflow-y-auto pb-16">
        <div className="p-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
};